import { app_config } from "../config/app.config";
import toast from "react-hot-toast";

const errorMessageFormat = (message) => {
  if (!message) return "";
  let words = message.split("_");
  words = words.map((word) => word.charAt(0).toUpperCase() + word.slice(1));
  let formattedMessage = words.join(" ");
  return formattedMessage;
};

export const toastSuccessMessage = (message) => {
  toast.success(errorMessageFormat(message), app_config.toast_config);
};

export const toastErrorMessage = (message) => {
  toast.error(errorMessageFormat(message), app_config.toast_config);
};

export function objectToFormData(formData, data, parentKey) {
  if (data == null) {
    // Skip null or undefined values
    return;
  }

  if (data instanceof File) {
    // Handle single File
    formData.append(parentKey, data);
  } else if (data instanceof FileList) {
    // Handle FileList (multiple files)
    for (let i = 0; i < data.length; i++) {
      formData.append(`${parentKey}[${i}]`, data[i]);
    }
  } else if (Array.isArray(data)) {
    // Handle arrays
    data.forEach((item, index) => {
      const key = `${parentKey}[${index}]`;
      objectToFormData(formData, item, key);
    });
  } else if (typeof data === "object" && data !== null) {
    if (data instanceof Date) {
      // Handle Date object
      formData.append(parentKey, data.toISOString());
    } else {
      // Handle nested objects
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          const newKey = parentKey ? `${parentKey}.${key}` : key;
          objectToFormData(formData, data[key], newKey);
        }
      }
    }
  } else {
    // Handle normal scalar data (string, number, boolean)
    formData.append(parentKey, data);
  }
}
